module.exports = __webpack_public_path__ + "media/images/frontend/slide-e8d3038b2bbe7bd44e3237b50348698c.webp";